<script setup lang="ts">
import { faArrowRight, faUser } from '@fortawesome/pro-regular-svg-icons';
import MrbilitIcon from '@components/layout/site-header/MrbilitIcon.vue';

const { title } = defineProps<{
    title: string;
}>();
const emit = defineEmits<{
    back: [];
}>();

const authStore = useAuthStore();
const { accountName, loggedIn } = classToRefs(authStore);

const authTitle = computed(() =>
    loggedIn.value ? accountName.value : 'ورود به حساب کاربری'
);
</script>

<template>
    <header class="header-wrapper">
        <div class="header-container">
            <!-- region mobile elements -->
            <mr-button
                class="back-btn mobile-only"
                :icon-button="{
                    icon: faArrowRight,
                    color: 'var(--cool-gray-900)',
                }"
                size="medium"
                variant="transparent"
                @click="emit('back')"
            />
            <mr-typography weight="700" class="mobile-only">
                {{ title }}
            </mr-typography>
            <!-- region end -->

            <!-- region desktop elements -->
            <MrbilitIcon class="desktop-only" color="white" />
            <div class="account desktop-only">
                <mr-icon :icon="faUser" color="white" />
                <mr-typography weight="700" color="white">
                    {{ authTitle }}
                </mr-typography>
            </div>
            <!-- region end -->
        </div>
        <slot />
    </header>
</template>

<style lang="scss" scoped>
.header-wrapper {
    background-color: usePalette($p-blue, $p-400);
    @include mobile-only {
        background-color: white;
    }
    width: 100vw;
    @include desktop-only {
        display: flex;
        flex-direction: column;
        gap: 21px;
        padding-bottom: 20px;
    }
    .header-container {
        display: grid;
        grid-template-columns: 0.1fr 1fr 0.1fr;
        gap: 10px;
        justify-items: center;
        align-items: center;
        padding-block: 5px;
        width: 100%;
        padding: 16px;
        .account {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding-inline: 12px;
        }
        @include desktop-only {
            max-width: 1100px;
            display: flex;
            justify-content: space-between;
            margin-inline: auto;
        }
    }
}
</style>
